import { 
  INITIATE_MEDIA_UPLOAD, INVALIDATE_UPLOAD_ERROR, UPDATE_MEDIA_UPLOAD_PROGRESS, UPLOAD_MEDIA_REQUEST, UPLOADING_MEDIA_SUCCEEDED, UPLOADING_MEDIA_FAILED,
  SEARCH_MEDIA_REQUEST, SEARCHING_MEDIA_SUCCEEDED, SEARCHING_MEDIA_FAILED, DELETE_MEDIA_REQUEST, DELETING_MEDIA_SUCCEEDED, 
  DELETING_MEDIA_FAILED, INVALIDATE_MEDIA_LIBRARY, FETCHING_EXTERNAL_LIBRARY, FETCHING_EXTERNAL_LIBRARY_SUCCEDED, 
  FETCHING_EXTERNAL_LIBRARY_FAILED, INVALIDATE_EXTERNAL_LIBRARY, INVALIDATE_MEDIA_DELETE_ERROR
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const pf_apiUrl = process.env.REACT_APP_PAPERFLITE_API_URL
const MEDIA_URL = `${apiUrl}/api/2.0/media`;

const EXTERNAL_MEDIA_URL = `${pf_apiUrl}/api/2.0/external_library`

/**
 * Initiate Media Library
*/
export const initiateMediaUpload = createAction(INITIATE_MEDIA_UPLOAD, (request, mediaTarget) => {
  return {request, mediaTarget};
});

export const updateMediaUploadProgress = createAction(UPDATE_MEDIA_UPLOAD_PROGRESS, (id, progress) => {
  return {id, progress};
});

export const uploadMedia = createAction(UPLOAD_MEDIA_REQUEST, (id, request, callback) => {
  return {id, request, callback};
})

export const uploadingMediaSucceeded = createAction(UPLOADING_MEDIA_SUCCEEDED, (id, response) => {
  return {id, response};
})

export const uploadingMediaFailed = createAction(UPLOADING_MEDIA_FAILED, (id, error) => {
  return {id, error};
})

function* uploadMediaSaga(action) {
  const {id, request, callback} = action.payload;

  const uploadMediaAPI = () => {
    return axios.post(MEDIA_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(uploadMediaAPI);
    if (response) {
      yield put(uploadingMediaSucceeded(id, response));
      if(callback) {
        callback(response);
      }
    }
  } catch (error) {
    yield put(uploadingMediaFailed(id, error));
  }
}

/**
 External Library
 */
export const fetchingExternalLibrary = createAction(FETCHING_EXTERNAL_LIBRARY, (request) => {
  return request;
});

export const fetchingExternalLibrarySucceded = createAction(FETCHING_EXTERNAL_LIBRARY_SUCCEDED, (response) => {
  return {response};
});

export const fetchingExternalLibraryFailed = createAction(FETCHING_EXTERNAL_LIBRARY_FAILED, (error) => {
  return {error};
});

export const invalidateExternalLibrary = createAction(INVALIDATE_EXTERNAL_LIBRARY);

function* fetchExternalMediaSaga(action) {
  const {mediaType, mediaLibraryType, orientation, page, query} = action.payload;

  const params = {
    type: mediaType,
    mediaLibraryType: mediaLibraryType,
    orientation : orientation,
    page: page,
    query: query
  };
  
  let url = buildUrl(EXTERNAL_MEDIA_URL, {
    queryParams: params
  });

  const fetchExternalMediaAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchExternalMediaAPI);
    if (response) {
      yield put(fetchingExternalLibrarySucceded(response));
    }
  } catch (error) {
    yield put(fetchingExternalLibraryFailed(error));
  }
}

/**
 * Search Media
 * 
*/
export const searchMedia = createAction(SEARCH_MEDIA_REQUEST, (request) => {
  return request;
});

const searchingMediaSucceeded = createAction(SEARCHING_MEDIA_SUCCEEDED, (request, response) => {
  return {request, response};
})

const searchingMediaFailed = createAction(SEARCHING_MEDIA_FAILED, (request, error) => {
  return { request, error };
});

function* searchMediaSaga(action) {
  const request = action.payload;

  const fetchAllMediaAPI = () => {
    return axios.post(`${MEDIA_URL}/search`, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchAllMediaAPI);
    yield put(searchingMediaSucceeded(request, response));
  } catch (error) {
    yield put(searchingMediaFailed(error));
  }
}

/**
 * Delete Media
 * 
*/
export const deleteMedia = createAction(DELETE_MEDIA_REQUEST, (id) => {
  return id;
});

const deleteingMediaSucceeded = createAction(DELETING_MEDIA_SUCCEEDED, (id, response) => {
  return { id, response };
})

const deleteingMediaFailed = createAction(DELETING_MEDIA_FAILED, (id, error) => {
  return { id, error };
});

function* deleteMediaSaga(action) {
  const id = action.payload;

  let url = buildUrl(MEDIA_URL, {
    path: id
  });

  const deleteMediaAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(deleteMediaAPI);
    yield put(deleteingMediaSucceeded(id, response));
  } catch (error) {
    yield put(deleteingMediaFailed(id, error));
  }
}

/**
 * Invalidate Upload Error
*/
export const invalidateUploadError = createAction(INVALIDATE_UPLOAD_ERROR);

/**
 * Invalidate Media Library
 * 
*/
export const invalidateMediaLibrary = createAction(INVALIDATE_MEDIA_LIBRARY);


/**
 * Delete Error
 */

export const invalidateMediaDeleteError=createAction(INVALIDATE_MEDIA_DELETE_ERROR);

export default function* mediaSaga() {
  yield takeEvery(UPLOAD_MEDIA_REQUEST, uploadMediaSaga);
  yield takeEvery(SEARCH_MEDIA_REQUEST, searchMediaSaga);
  yield takeEvery(DELETE_MEDIA_REQUEST, deleteMediaSaga);
  yield takeEvery(FETCHING_EXTERNAL_LIBRARY, fetchExternalMediaSaga);
}